import React from "react";
import { RadioGroupState } from "@react-stately/radio";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const RadioContext = React.createContext<RadioGroupState>(null!);
